import { render, staticRenderFns } from "./CriarImplantacao.vue?vue&type=template&id=149e9e17&"
import script from "./CriarImplantacao.vue?vue&type=script&lang=js&"
export * from "./CriarImplantacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports